import * as React from 'react';
import Svg, {Path, SvgProps} from 'react-native-svg';

type Props = SvgProps & {
  color?: string;
};

const DishPlusSvg: React.FC<Props> = ({color = '#0C1D2E', ...props}) => {
  return (
    <Svg width={14} height={14} fill='none' {...props}>
      <Path
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.2}
        d='M6.955 2.917v8.166M2.898 7h8.114'
      />
    </Svg>
  );
};

export default DishPlusSvg;
